import type { Notification } from '../model/types'
import { firstLine, parseChanges } from './helpers'

const formatVal = (v: string) => (v === '' ? '—' : v)

export function buildBody(
  notification: Notification,
  fieldLabels: Record<string, string>,
  hideField?: (field: string) => boolean
): React.ReactNode | undefined {
  const changes = parseChanges(notification, fieldLabels, hideField)
  const line = firstLine(notification.message)
  if (!line && changes.length === 0) return undefined

  return (
    <div className="text-foreground text-sm">
      {line && <p className="mb-1">{line}</p>}
      {changes.length > 0 && (
        <ul className="list-disc space-y-0.5 pl-4 text-xs">
          {changes.map((c, i) => (
            <li key={i}>
              <span className="font-medium">{c.label}: </span>
              {c.hasOld ? (
                <>
                  <span className="text-secondary line-through">{formatVal(c.old)}</span>
                  <span className="text-green"> → {formatVal(c.new)}</span>
                </>
              ) : (
                <span className="text-green">{formatVal(c.new)}</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
